"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var easy_peasy_1 = require("easy-peasy");
var ui = {
    hasTitle: '',
    appConfig: {},
    hasHeader: true,
    menuFullCollapsed: false,
    menuIconCollapsed: false,
    masterAreaCollapsed: false,
    helpAreaCollapsed: true,
    hasMenu: false,
    hasMasterArea: false,
    isMobile: false,
    workspaceToolbar: undefined,
    setHasTitle: easy_peasy_1.action(function (state, payload) {
        state.hasTitle = payload;
    }),
    setHasHeader: easy_peasy_1.action(function (state, payload) {
        state.hasHeader = payload;
    }),
    setAppConfig: easy_peasy_1.action(function (state, payload) {
        state.appConfig = payload;
    }),
    setHasMenu: easy_peasy_1.action(function (state, payload) {
        state.hasMenu = payload;
    }),
    setHasMasterArea: easy_peasy_1.action(function (state, payload) {
        state.hasMasterArea = payload;
    }),
    setMenuFullCollapsed: easy_peasy_1.action(function (state, payload) {
        state.menuFullCollapsed = payload;
        state.menuIconCollapsed = false;
    }),
    setMenuIconCollapsed: easy_peasy_1.action(function (state, payload) {
        state.menuIconCollapsed = payload;
        state.menuFullCollapsed = false;
    }),
    setMasterAreaCollapsed: easy_peasy_1.action(function (state, payload) {
        state.masterAreaCollapsed = payload;
    }),
    setHelpAreaCollapsed: easy_peasy_1.action(function (state, payload) {
        state.helpAreaCollapsed = payload;
    }),
    setIsMobile: easy_peasy_1.action(function (state, payload) {
        state.isMobile = payload;
    }),
    toggleMenuFullCollapse: easy_peasy_1.action(function (state) {
        state.menuFullCollapsed = !state.menuFullCollapsed;
        state.menuIconCollapsed = false;
    }),
    toggleMenuIconCollapse: easy_peasy_1.action(function (state) {
        state.menuIconCollapsed = !state.menuIconCollapsed;
        state.menuFullCollapsed = false;
    }),
    toggleMasterAreaCollapse: easy_peasy_1.action(function (state) {
        state.masterAreaCollapsed = !state.masterAreaCollapsed;
    }),
    toggleHelpAreaCollapse: easy_peasy_1.action(function (state) {
        state.helpAreaCollapsed = !state.helpAreaCollapsed;
    }),
    setGuide: easy_peasy_1.action(function (state, payload) {
        state.guide = payload;
    }),
    setWorkspaceToolbar: easy_peasy_1.action(function (state, payload) {
        state.workspaceToolbar = payload;
    }),
};
exports.default = ui;
